<script>
import { ExclamationCircleIcon } from '@heroicons/vue/20/solid'

export default {
    components: {
        ExclamationCircleIcon
    },

    emits: ['update:modelValue', 'blur'],

    props: {
        label: {
            type: String,
        },

        id: {
            type: String,
            required: true
        },

        type: {
            type: String,
            default: 'text'
        },

        error: {
            type: String,
            default: ''
        },

        placeholder: {
            type: String,
            default: ''
        },

        theme: {
            type: String,
            default: 'light',
            validate: (value) => {
                return ['dark', 'light'].includes(value)
            }
        },

        modelValue: {
            type: [String, Number]
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            value: this.modelValue
        }
    },
}
</script>

<template>
    <div :class="[theme === 'dark' ? 'input-theme-dark' : 'input-theme-light']" v-auto-animate>
        <label :for="id" class="block text-base font-medium" v-if="label" v-html="label"></label>

        <div class="relative mt-1 rounded-md" v-auto-animate>
            <input :type="type" :name="id" :id="id" :class="[error ? 'error' : '']"
                class="block w-full rounded-md pr-10 border-solid py-3 bg-bi-light-gray font-bi-text-medium placeholder:font-bi-text text-base text-bi-dark-green placeholder-bi-gray-60"
                :placeholder="placeholder" value="" :aria-invalid="!error ? 'false' : 'true'"
                :aria-describedby="`${id}-error`" v-model="value" :disabled="disabled"
                @input="$emit('update:modelValue', value)" />
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" v-if="error">
                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
            </div>
        </div>

        <p class="mt-2 text-base" :id="`${id}-error`" v-if="error">
            {{ error }}
        </p>
    </div>
</template>

<style lang="scss" scoped>
.input-theme-dark {
    label {
        @apply text-white;
    }

    input {
        @apply border-2 focus:outline-none focus:shadow-none border-transparent focus:border-bi-accent-green ring-0;
    }

    input.error {
        @apply border-red-400 placeholder-red-400 focus:border-red-400 border-2 focus:ring-red-500 text-red-900;
    }

    input:disabled {
        @apply bg-gray-700 text-gray-400 cursor-not-allowed;
    }

    p {
        @apply text-red-400;
    }
}

.input-theme-light {
    label {
        @apply text-bi-dark-green;
    }

    input {
        @apply border-bi-warm-gray border-2 focus:outline-none shadow-none focus:border-bi-accent-green ring-0 bg-bi-white;
    }

    input:disabled {
        @apply bg-gray-50 cursor-not-allowed;
    }

    input.error {
        @apply border-red-300 placeholder-red-300 focus:border-red-500 border-2 focus:ring-red-500 text-red-900;
    }

    p {
        @apply text-red-600;
    }
}
</style>
